import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "./networkService";

export async function fetchRegistyNames(){
    try{
        const url = "/v1/registry/meta/target?source=portal&callType=scheduled";
        const response = await ChannelkartNetworkGet(url);
        if(response.status === 200 || response.status === 201){
            return response.data.features;
        }else{
            throw new Error();
        }
    }catch(err){
        console.log(err);
        throw new Error();
    }
}
export async function fetchRegistryConfigNames(registryName: string){
    try{
        const url = `/v1/registry/meta/${registryName}/id?source=portal&callType=scheduled`;
        const response = await ChannelkartNetworkGet(url);
        if(response.status === 200 || response.status === 201){
            return response.data.features;
        }else{
            throw new Error();
        }
    }catch(err){
        console.log(err);
        throw new Error();
    }
}
export async function fetchRegistryValues(registryName: string,registryConfigName: string){
    try{
        const url = `/v1/registry/data/${registryName}/${registryConfigName}?source=portal&callType=scheduled`;
        const response = await ChannelkartNetworkGet(url);
        if(response.status === 200 || response.status === 201){
            return response.data.features[0];
        }else{
            throw new Error();
        }
    }catch(err){
        console.log(err);
        throw new Error();
    }
}
export function isValidJson(jsonStr: string) {
    if(typeof(jsonStr)!== "string") return false;
    try {
        JSON.parse(jsonStr);
        return true;
      } catch (error) {
        return false;
      }
  }